import { Box, Button, Paper, Typography } from '@mui/material';
import DraftsIcon from '@mui/icons-material/Drafts';

import { useCheckEmail } from './hooks';

interface CheckEmailProps {
  email: string;
  captcha_id: string;
  captcha_answer: string;
  validateEmail: (data: {
    email: string;
    captcha_id: string;
    captcha_answer: string;
  }) => void;
}

export const CheckEmail = ({
  email,
  captcha_id,
  captcha_answer,
  validateEmail,
}: CheckEmailProps) => {
  const { handleButtonClick, handleReturnToLogin } = useCheckEmail(
    {
      email,
      captcha_answer,
      captcha_id,
    },
    validateEmail,
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '3.5rem',
        width: '28rem',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '2rem',
          gap: '2rem',
          width: '100%',
          borderRadius: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <DraftsIcon sx={{ fontSize: '3rem' }} color='primary' />
          <Typography
            variant='h5'
            sx={{ fontWeight: '600', fontSize: '1.5rem', color: 'primary' }}
          >
            Check your email
          </Typography>
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '1rem',
              textAlign: 'center',
              pt: '1.25rem',
              color: 'primary',
            }}
          >
            If there's an account associated with this email address, we've sent
            a link to reset your password.
          </Typography>
        </Box>

        <Button
          variant='outlined'
          sx={{
            width: '100%',
            padding: '0.5rem',
            fontWeight: '500',
          }}
          onClick={handleButtonClick}
        >
          RESEND
        </Button>
        <Button
          variant='text'
          sx={{ width: '100%', padding: '0.5rem', fontWeight: '500' }}
          onClick={handleReturnToLogin}
        >
          RETURN TO LOGIN
        </Button>
      </Paper>
    </Box>
  );
};
